export type GameSearch = { gameId?: string; dev?: boolean };

export const validateGameSearch = (
  search: Record<string, unknown>,
): GameSearch => ({
  gameId: typeof search.gameId === "string" ? search.gameId : undefined,
  dev: search.dev ? true : undefined,
});
